import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import debounce from 'debounce-promise';
import apiClient from 'helpers/api-client';
import TextInputField from './TextInputField';

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/;

const uniqueEmailMessage = (
  <FormattedMessage
    id="Onboard.form_validation_email_unique"
    description="Unique email validation"
    defaultMessage="Email already taken"
  />
);

const EmailAddress = ({
  emailExistsError,
  setEmailExistsError,
  setEmailValidating,
}) => {
  const { formatMessage } = useIntl();

  const onChange = debounce((email) => {
    if (!email || !email.match(emailRegex)) return;

    apiClient.get('/signup/existing_user', { email }).then(({ exists }) => {
      const error = exists ? uniqueEmailMessage : '';
      setEmailExistsError(error);
      setEmailValidating(false);
    });
  }, 500);

  const validateEmail = useCallback(onChange, [
    setEmailExistsError,
    setEmailValidating,
  ]);

  return (
    <TextInputField
      showClearIcon
      name="email"
      type="email"
      error={emailExistsError}
      placeholder={formatMessage({ id: 'Common.workEmail' })}
      onChange={({ target }) => {
        setEmailExistsError('');
        setEmailValidating(true);
        validateEmail(target.value);
      }}
    />
  );
};

EmailAddress.propTypes = {
  emailExistsError: PropTypes.string,
  setEmailExistsError: PropTypes.func,
  setEmailValidating: PropTypes.func,
};

export default EmailAddress;
